var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"roundel-row"},_vm._l((_vm.listOfResources),function(v){return _c('ResourceLabel',{key:v,attrs:{"id":v,"resFunction":_vm.resFunction}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }